import { render, staticRenderFns } from "./PageInformationText.vue?vue&type=template&id=cf265ae2&scoped=true&"
import script from "./PageInformationText.vue?vue&type=script&lang=js&"
export * from "./PageInformationText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf265ae2",
  null
  
)

export default component.exports